import ConditionalRule from "../../../../common/models/conditionalRules/conditionalRule";
import FormElement from "../formElements/formElement";
import {DatetimeMode} from "../../../../common/models/datetimeMode";
import Repo from "../../../../common/state/modules/repo";
import IRepo from "../../../../common/interfaces/repo";

export default class FormElementConditionalRule extends ConditionalRule {
  static repo: IRepo<FormElementConditionalRule> = new Repo<FormElementConditionalRule>('conditionalRules', FormElementConditionalRule);

  get referencedControl(): FormElement {
    return FormElement.repo.find(this.referenced_control_id);
  }

  getValueString(id: string): string {
    const element = FormElement.repo.find(id);
    return element ? element.label_title : '';
  }
}